import { ControlOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useMapboxContext } from "../context/mapbox-context";

const ButtonFilter = () => {
    const { isOpenFilterDrawer, setIsOpenFilterDrawer } = useMapboxContext();

const openFilterDrawer = () => {
    setIsOpenFilterDrawer(!isOpenFilterDrawer)
}

return (<Button icon={<ControlOutlined style={{fontSize:"23px"}}/> } style={{margin:"5px"}} onClick={() => openFilterDrawer()}/>)
}

export default ButtonFilter;